// src/App.tsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ChatInterface from './components/Chat/ChatInterface';
import GuestOrderLanding from './components/Chat/GuestOrderLanding';

const ContactLinks: React.FC = () => (
    <div className="fixed bottom-4 left-4 z-50 flex flex-col gap-2">
        <a
            href="https://zalo.me/0336662221"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Liên hệ qua Zalo"
            className="flex items-center gap-2 rounded-full bg-blue-600 px-4 py-3 text-sm font-semibold text-white shadow-lg transition hover:bg-blue-700"
        >
            <span aria-hidden="true" className="flex h-7 w-7 items-center justify-center rounded-full bg-white text-xs font-bold text-blue-600">Zalo</span>

        </a>
    </div>
);

const AppContent: React.FC = () => {
    const { user, isAuthenticated, isLoading } = useAuth();
    console.log('📱 AppContent - isAuthenticated:', isAuthenticated, 'user:', user);

    return (
        <SocketProvider>
            <Routes>
                <Route
                    path="/"
                    element={isLoading
                        ? <div className="flex min-h-screen items-center justify-center text-gray-600">Đang tải...</div>
                        : isAuthenticated
                            ? <ChatInterface userId={user?._id || ''} username={user?.username || ''} />
                            : <GuestOrderLanding />}
                />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ContactLinks />
        </SocketProvider>
    );
};

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppContent />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;